import angular from 'angular';

import { ClickableCardComponent } from './clickable-card.component';

angular
  .module('core.components.clickable-card', [])
  .component('easyshipClickableCard', ClickableCardComponent);
